export default function initChart() {
  const iframes = document.querySelectorAll("iframe.chart")

  if (!iframes.length) return

  window.addEventListener("message", (event) => {
    iframes.forEach((iframe) => {
      if (iframe.contentWindow === event.source) {
        iframe.style.height = `${event.data + 10}px`
      }
      iframe.style.overflow = "hidden"
    })
  })
}
